<template lang="html">
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script lang="js">
// import AppHeader from '../src/components/partials/AppHeader'
// import AppSidebar from '../src/components/partials/AppSidebar'
// import AppFooter from '../src/components/partials/AppFooter'
export default{
  name: 'appp',
  components: {
  },
  mounted () {
  }
}
</script>

<style>
  @import "../node_modules/mdi/css/materialdesignicons.min.css";
  @import "../node_modules/flag-icon-css/css/flag-icon.min.css";
  @import "../node_modules/font-awesome/css/font-awesome.min.css";

</style>

<style lang="scss">
  @import "./assets/scss/style";
</style>



// WEBPACK FOOTER //
// src/App.vue